import { Flex } from '@shared/components';

import { QuestionnaireReportTable } from '../../components';

import { type StandardTemplateSection } from './utils';

interface QuestionnaireReportStandardSectionProps {
  section: StandardTemplateSection;
  /** Forwarded to every QuestionnaireReportTable rendered by this section. */
  loading?: boolean;
}

export default function QuestionnaireReportStandardSection({
  section,
  loading,
}: QuestionnaireReportStandardSectionProps) {
  const hasSubSections = (section.subSections?.length ?? 0) > 0;

  if (hasSubSections) {
    return (
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          border: '1px solid #262626',
          borderRadius: theme.shape.rounded(2),
          overflowX: 'auto',
          overflowY: 'hidden',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          '&::-webkit-scrollbar': { display: 'none' },
          backgroundColor: '#ffffff',
          width: 'fit-content',
          maxWidth: '100%',
        })}
      >
        <QuestionnaireReportTable
          title={section.title}
          rows={section.rows}
          total={section.total}
          variant={section.variant}
          standalone={false}
          loading={loading}
        />
        {section.subSections?.map((sub) => (
          <QuestionnaireReportTable
            key={sub.key}
            title={sub.title}
            rows={sub.rows}
            total={sub.total}
            variant={sub.variant}
            standalone={false}
            loading={loading}
          />
        ))}
      </Flex>
    );
  }

  return (
    <QuestionnaireReportTable
      title={section.title}
      rows={section.rows}
      total={section.total}
      variant={section.variant}
      loading={loading}
    />
  );
}
